import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockKeyholeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    viewBox="0 0 19 18"
    {...props}
  >
    <path
      fill="#000"
      d="M9.77 9.94c.198 0 .39.075.53.208.14.132.22.313.22.5v2.125a.7.7 0 0 1-.22.501.77.77 0 0 1-.53.208.77.77 0 0 1-.53-.208.7.7 0 0 1-.22-.5v-2.126c0-.187.079-.368.22-.5a.77.77 0 0 1 .53-.208M6.02 7.107V5.69c0-.94.395-1.84 1.098-2.504A3.87 3.87 0 0 1 9.77 2.148c.994 0 1.948.374 2.651 1.038A3.45 3.45 0 0 1 13.52 5.69v1.417c.596 0 1.169.224 1.59.622.423.399.66.94.66 1.503v4.958c0 .564-.237 1.104-.66 1.503a2.32 2.32 0 0 1-1.59.622h-7.5a2.32 2.32 0 0 1-1.591-.622 2.07 2.07 0 0 1-.66-1.503V9.232c0-.564.238-1.104.66-1.503a2.32 2.32 0 0 1 1.59-.622m6-1.417c0-.563-.237-1.104-.66-1.503a2.32 2.32 0 0 0-1.59-.622c-.597 0-1.17.224-1.591.623a2.07 2.07 0 0 0-.66 1.502v1.417h4.5zm-6.75 8.5a.7.7 0 0 0 .22.501c.14.133.33.207.53.207h7.5c.198 0 .39-.074.53-.207a.7.7 0 0 0 .22-.5V9.23a.7.7 0 0 0-.22-.5.77.77 0 0 0-.53-.208h-7.5a.77.77 0 0 0-.53.208.7.7 0 0 0-.22.5z"
    />
  </svg>
);
export default SvgLockKeyholeIcon;
